const errorMessage_zh = {
	defaultErrorMsg: '[中文]defaultErrorMsg',
	OIM0056: '[中文]OIM0056 message'
};

export default errorMessage_zh;
